import { useState } from 'react';
import { Button, Dialog, DialogProps, Stack, StackItem } from '@optimus-web/core';
import { SimpleList, SimpleListItem } from '@optimus-web/core/src/SimpleList';
import { lt } from '@mews/framework';
import { ApplicableBillType } from '@mews-commander/data-access';

interface Props extends DialogProps {
    onSubmit: () => Promise<void>;
    applicableBillType: ApplicableBillType;
}

export const CreditNoteCounterDefaultWarningDialog = ({ active, onClose, applicableBillType, onSubmit }: Props) => {
    const [isLoading, setIsLoading] = useState(false);

    return (
        <Dialog
            loading={isLoading}
            footer={{
                primary: (
                    <Button
                        onClick={async (e) => {
                            try {
                                setIsLoading(true);
                                await onSubmit();
                                onClose?.(e);
                            } finally {
                                setIsLoading(false);
                            }
                        }}
                        variant="primary"
                        type="submit"
                    >
                        {lt('Confirm')}
                    </Button>
                ),
                secondary: (
                    <Button onClick={onClose} type="submit">
                        {lt('Cancel')}
                    </Button>
                ),
            }}
            title={lt('CreditNoteCounterDefaultConfirmTitle')}
            onClose={onClose}
            active={active}
        >
            <Stack vertical spacing="300">
                <StackItem>{lt('CreditNoteCounterDefaultConfirmInfo')}</StackItem>
                <SimpleList>
                    {applicableBillType.applyToBill ? <SimpleListItem>{lt('BillPlural')}</SimpleListItem> : null}
                    {applicableBillType.applyToInvoice ? <SimpleListItem>{lt('InvoicePlural')}</SimpleListItem> : null}
                </SimpleList>
            </Stack>
        </Dialog>
    );
};
